import { render, staticRenderFns } from "./english.vue?vue&type=template&id=88a7f610&"
import script from "./english.vue?vue&type=script&lang=js&"
export * from "./english.vue?vue&type=script&lang=js&"
import style0 from "./english.vue?vue&type=style&index=0&id=88a7f610&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports